<script setup>
import TopBarComponent from "./components/TopBarComponent.vue";
import { isLoggedIn, logout } from "@/utils/auth.js";
</script>

<template>
  <v-container :fluid="true">
    <v-layout>
      <TopBarComponent />
      <v-navigation-drawer permanent>
        <v-list color="transparent">
          <template
            v-for="route in $router.options.routes"
            :key="route?.meta?.requiresAuth"
          >
            <v-list-item
              v-if="
                (isLoggedIn() && route?.meta?.requiresAuth) ||
                (!isLoggedIn() && !route?.meta?.requiresAuth)
              "
              :prepend-icon="route.icon"
            >
              <router-link style="text-decoration: none" :to="route.path">
                {{ route.name }}
                <v-tooltip activator="parent" location="end" max-width="250px">{{
                  route.description
                }}</v-tooltip>
              </router-link>
            </v-list-item>
          </template>
        </v-list>

        <template v-slot:append v-if="isLoggedIn()">
          <div class="pa-2">
            <v-btn @click="logout"> Sign out </v-btn>
          </div>
        </template>
      </v-navigation-drawer>

      <v-main>
        <router-view v-slot="{ Component }">
          <Transition name="slide-fade">
            <component :is="Component" />
          </Transition>
        </router-view>
      </v-main>
    </v-layout>
  </v-container>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #adadad;
}

nav a.router-link-exact-active {
  color: #3c57d3;
}

.v-list > .v-list-item {
  border-bottom: solid rgba(0, 0, 0, 0.1) 1px;
  min-height: 90px;
}

.v-list > .v-list-item:first-child {
  border-top: solid rgba(0, 0, 0, 0.1) 1px;
}
</style>
